var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { replaceScriptNode } from "@grebban/replace-script-node-js";
// Updated on 2021-12-14
export var INGRID_SUPPORTED_LOCALES = {
  'cs-CZ': 'Czech',
  'da-DK': 'Danish',
  'de-AT': 'Austrian German',
  'de-BE': 'Belgian German',
  'de-CH': 'Swiss German',
  'de-DE': 'German',
  'de-LU': 'Luxembourgish German',
  'el-GR': 'Greek',
  'en-AU': 'Australian English',
  'en-CA': 'Canadian English',
  'en-GB': 'British English',
  'en-IE': 'Irish English',
  'en-US': 'American English',
  'es-ES': 'Spanish',
  'et-EE': 'Estonian',
  'fi-FI': 'Finnish',
  'fi-SE': 'Swedish Finnish',
  'fr-BE': 'Belgian French',
  'fr-CA': 'Canadian French',
  'fr-CH': 'Swiss French',
  'fr-FR': 'French',
  'fr-LU': 'Luxembourgish French',
  'hr-HR': 'Croatian',
  'is-IS': 'Icelandic',
  'it-CH': 'Swiss Italian',
  'it-IT': 'Italian',
  'ja-JP': 'Japanese',
  'ko-KR': 'Korean',
  'lt-LT': 'Lithuanian',
  'lv-LV': 'Latvian',
  'nb-NO': 'Norwegian Bokmål',
  'nl-BE': 'Flemish',
  'nl-NL': 'Dutch',
  'nn-NO': 'Norwegian Nynorsk',
  'no-NO': 'Norwegian',
  'pl-PL': 'Polish',
  'pt-PT': 'Portuguese',
  'ru-RU': 'Russian',
  'sk-SK': 'Slovak',
  'sl-SI': 'Slovenian',
  'sv-FI': 'Finland Swedish',
  'sv-SE': 'Swedish',
  'zh-CN': 'Simplified Chinese'
};
var INGRID_VALID_JS_API_EVENTS_WITH_PARAMETERS = {
  'data_changed': ['data', 'meta'],
  'loaded': [],
  'no_shipping_options': [],
  'address_changed': ['address'],
  'door_code_changed': ['doorCode'],
  'courier_instructions_changed': ['instructions'],
  'shipping_option_changed': ['option']
};
export var INGRID_VALID_JS_API_EVENTS = Object.keys(INGRID_VALID_JS_API_EVENTS_WITH_PARAMETERS);
var IngridDelivery = /** @class */function (_super) {
  __extends(IngridDelivery, _super);
  function IngridDelivery(props) {
    var _this = _super.call(this, props) || this;
    _this.setupGrebbanIngridGlobalScope = function () {
      var _a = _this.props,
        onLoad = _a.onLoad,
        onError = _a.onError;
      window.grebban = window.grebban || {};
      var globalIngrid = window.grebban.ingrid = window.grebban.ingrid || {};
      globalIngrid.sessionId = _this.sessionId;
      globalIngrid.loadError = function () {
        return onError({
          error: 'Could not load the Ingrid script'
        });
      };
      globalIngrid.loaded = onLoad;
    };
    _this.loadScript = function () {
      var snippet = _this.props.data.snippet;
      // Check which kind of script this is, new or old.
      var scriptKey = snippet.includes('script.async = true;') ? 'script' : 'bootstrapScript';
      // Injecting the HTMLSnippet into the dom will setup the app via iframes
      // and secure channels of communication between the iframes and the page
      _this.widgetWrapperRef.current.innerHTML = snippet.replace("".concat(scriptKey, ".async = true;"), "".concat(scriptKey, ".async = true;").concat(scriptKey, ".onerror = window.grebban.ingrid.loadError;").concat(scriptKey, ".onload = window.grebban.ingrid.loaded;"));
      // Most browsers will not automatically run an injected script
      // We have to clone it, to trick the browser into running it
      // Also, the container name from the snippet is "shipwallet-container" so it has to be hardcoded.
      replaceScriptNode(document.getElementById("shipwallet-container"));
      _this.initAPI();
    };
    _this.initAPI = function () {
      if (!window._sw) {
        // This should not happen since it seem that the window._sw is created by the Ingrid-snippet from Centra.
        return;
      }
      var eventCallback = _this.props.eventCallback;
      window._sw(function (api) {
        window.grebban.ingrid.ingridJsApi = api;
        Object.keys(INGRID_VALID_JS_API_EVENTS_WITH_PARAMETERS).forEach(function (eventName) {
          var parameters = INGRID_VALID_JS_API_EVENTS_WITH_PARAMETERS[eventName];
          api.on(eventName, function () {
            var data = {};
            var _arguments = arguments; // Typescript will trigger an "error" 2 rows down if we don't do this
            parameters.forEach(function (parameter, paramIndex) {
              data[parameter] = _arguments[paramIndex];
            });
            eventCallback(eventName, __assign({}, data));
          });
        });
      });
    };
    _this.widgetWrapperRef = React.createRef();
    _this.sessionId = Math.random().toString(36).substr(2, 9);
    return _this;
  }
  IngridDelivery.prototype.componentDidMount = function () {
    this.setupGrebbanIngridGlobalScope();
    this.loadScript();
  };
  IngridDelivery.prototype.componentWillUnmount = function () {
    window.grebban.ingrid = false;
  };
  IngridDelivery.prototype.componentDidCatch = function (error, errorInfo) {
    var onError = this.props.onError;
    onError({
      error: error,
      errorInfo: errorInfo
    });
  };
  IngridDelivery.prototype.render = function () {
    return React.createElement("div", {
      ref: this.widgetWrapperRef
    });
  };
  IngridDelivery.propTypes = {
    data: PropTypes.shape({
      snippet: PropTypes.string.isRequired
    }).isRequired,
    onError: PropTypes.func,
    onLoad: PropTypes.func,
    eventCallback: PropTypes.func
  };
  IngridDelivery.defaultProps = {
    onError: function onError(error) {},
    onLoad: function onLoad() {},
    eventCallback: function eventCallback() {}
  };
  return IngridDelivery;
}(Component);
export default IngridDelivery;